import { makeStyles } from '@material-ui/core/styles';

import type { CustomTheme } from 'theme';

const useStyles = makeStyles((theme: CustomTheme) => ({
  headerContainer: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
  },
  header: {
    [theme.breakpoints.up('md')]: {
      minHeight: theme.spacing(10), // 80px
    },
  },
  headerLogoContainer: {
    minWidth: theme.spacing(21.875), // 175px
    maxHeight: theme.spacing(3), // 24px
  },
  headerLogo: {
    maxHeight: 'inherit',
    width: '100%',
  },
  helpGroup: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  headerIconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default useStyles;
